import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  filterByName,
  getClients,
  orderByPodcasts,
  setClient,
  sortClients,
  sortClientsName,
} from "../../../../slices/clientesSlice";
import clientIcon from "../../../../assets/clientIcon.png";
import phone from "../../../../assets/phone.svg";
import mail from "../../../../assets/mail.svg";
import {
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
  Eye,
  Navigation,
  Pencil,
  Trash,
} from "lucide-react";
import ClienteModal from "../../../../components/modales/Cliente/ClienteModal";
import ModalDeleteClient from "../../../../components/modales/Cliente/DeleteModal";
import ModalEditCliente from "../../../../components/modales/Cliente/EditModal";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

export default function GuestList() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { listClients } = useSelector((state) => state.clientes);
  const { isDarkMode } = useSelector((state) => state.darkMode);

  //* Estados para modales
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);

  //* Paginacion
  const [currentPage, setCurrentPage] = useState(1);
  const clientsForPage = 8;
  const startIndex = (currentPage - 1) * clientsForPage;
  const endIndex = startIndex + clientsForPage;
  const clientsPaginates = listClients.slice(startIndex, endIndex);
  const totalPages = Math.ceil(listClients.length / clientsForPage);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  //* Estados sort
  const [order, setOrder] = useState("");
  const [orderPodcast, setOrderPodcast] = useState("");
  const [name, setName] = useState("");

  //? Alertas
  const [messageApi, contextHolder] = message.useMessage();

  const successEditClient = () => {
    messageApi.open({
      type: "success",
      content: "Cliente actualizado correctamente!",
    });
  };
  const errorEditClient = () => {
    messageApi.open({
      type: "error",
      content: "Error al actualizar el cliente",
    });
  };

  const handleViewModal = (cliente) => {
    dispatch(setClient(cliente));
    setIsModalOpen(true);
  };

  const handleDeleteModal = (cliente) => {
    dispatch(setClient(cliente));
    setIsDeleteModal(true);
  };

  const handleEditModal = (cliente) => {
    dispatch(setClient(cliente));
    setIsEditModal(true);
  };

  const handleEditToView = () => {
    setIsModalOpen(false);
    setIsEditModal(true);
  };

  const handleChangeName = (e) => {
    const name = e.target.value;
    setName(name);
    dispatch(filterByName(name));
    //setCurrenPage(1);
  };

  const handlerOrderName = () => {
    let newOrder = "";
    if (order === "") {
      newOrder = "asc";
    } else if (order === "asc") {
      newOrder = "desc";
    } else if (order === "desc") {
      newOrder = "";
    }
    setOrder(newOrder);
    dispatch(sortClientsName(newOrder));
    // setCurrenPage(1);
  };

  const handlerByPodcast = () => {
    let newOrder = "";
    if (orderPodcast === "") {
      newOrder = "asc";
    } else if (orderPodcast === "asc") {
      newOrder = "desc";
    } else if (orderPodcast === "desc") {
      newOrder = "";
    }
    setOrderPodcast(newOrder);
    dispatch(orderByPodcasts(newOrder));
  };

  const handleNavigate = (client) => {
    dispatch(setClient(client))
    navigate("/admin/podcastsCliente")
  }

  useEffect(() => {
    dispatch(getClients());
  }, [dispatch]);

  return (
    <div className="sm:p-6 p-0 bg-background min-h-screen">
      {contextHolder}

      <ClienteModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleEditToView={handleEditToView}
      />
      <ModalDeleteClient
        isDeleteModal={isDeleteModal}
        setIsDeleteModal={setIsDeleteModal}
      />
      <ModalEditCliente
        isEditModal={isEditModal}
        setIsEditModal={setIsEditModal}
        successEditClient={successEditClient}
      />

      <section className="container mx-auto sm:p-5 p-2 font-poppina">
        <div className="w-full mb-8 overflow-hidden rounded-lg shadow-sm">
          <div className="flex justify-end mb-3">
            <input
              className="bg-background text-text w-[220px] rounded"
              type="text"
              value={name}
              onChange={handleChangeName}
              placeholder="Buscar por nombre"
            />
          </div>

          <div className="w-full overflow-hidden rounded-lg border border-border overflow-x-auto">
            <table className="w-full text-sm text-gray-700  ">
              <thead className="bg-background">
                <tr className="text-left">
                  <th
                    onClick={handlerOrderName}
                    className="p-2 sm:p-4 cursor-pointer items-center gap-1 text-subtitle"
                  >
                    Cliente
                    <span className="text-sm ml-2">
                      {order === "asc" && "▲"}
                      {order === "desc" && "▼"}
                      {order === "" && "↕"}
                    </span>
                  </th>
                  <th className="p-2 sm:p-4 hidden md:table-cell text-subtitle">
                    Datos
                  </th>
                  <th
                    onClick={handlerByPodcast}
                    className="p-2 sm:p-4 cursor-pointer hidden md:table-cell text-subtitle"
                  >
                    Cantidad de podcast
                    <span className="text-sm ml-2">
                      {orderPodcast === "asc" && "▲"}
                      {orderPodcast === "desc" && "▼"}
                      {orderPodcast === "" && "↕"}
                    </span>
                  </th>
                  <th className="p-2 sm:p-4 hidden md:table-cell text-subtitle">
                    Podcast activos
                  </th>
                  <th className="p-2 sm:p-4 text-center text-subtitle">
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {listClients.length > 0 ? (
                  clientsPaginates.map((cliente, index) => (
                    <tr
                      key={index}
                      className={`transition-colors ${
                        isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                      }`}
                    >
                      <td
                        className="p-2 sm:p-4"
                        style={{
                          maxWidth: "120px",
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        <div className="flex items-center text-sm">
                          <div className="relative w-8 h-8 mr-3 rounded-full">
                            <img
                              className="object-cover w-full h-full rounded-full"
                              src={
                                cliente.profileImage
                                  ? cliente.profileImage
                                  : clientIcon
                              }
                              alt=""
                              loading="lazy"
                            />
                          </div>
                          <div>
                            <p className="font-semibold text-text">
                              {cliente.name || "Sin nombre"}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="p-2 sm:p-4 hidden md:table-cell">
                        <div className="space-y-1">
                          <p className="text-xs sm:text-sm flex items-center text-text">
                            <img
                              src={phone}
                              alt="Teléfono"
                              className="w-4 h-4 mr-2"
                            />
                            +{cliente.phone || "S/N"}
                          </p>
                          <p className="text-xs sm:text-sm flex items-center text-text">
                            <img src={mail} alt="Email" className="C mr-2" />
                            {cliente.email || "Sin email"}
                          </p>
                        </div>
                      </td>
                      <td className="p-2 sm:p-4 hidden md:table-cell">
                        <p className="text-xs sm:text-sm text-text">
                          {cliente.totalPodcasts || "0"}
                        </p>
                      </td>
                      <td className="p-2 sm:p-4 hidden md:table-cell">
                        <p className="text-xs sm:text-sm text-text">
                          {cliente.activePlan || "0"}
                        </p>
                      </td>
                      <td className="p-2 sm:p-4">
                        <div className="flex justify-center gap-2">
                          <button
                            onClick={() => handleViewModal(cliente)}
                            className="p-1.5 sm:p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition"
                          >
                            <Eye className="w-4 h-4 sm:w-5 sm:h-5" />
                          </button>
                          <button
                            onClick={() => handleEditModal(cliente)}
                            className="p-1.5 sm:p-2 text-blue-500 hover:text-blue-700 hover:bg-blue-100 rounded-lg transition"
                          >
                            <Pencil className="w-4 h-4 sm:w-5 sm:h-5" />
                          </button>
                          <button
                            onClick={() => handleDeleteModal(cliente)}
                            className="p-1.5 sm:p-2 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-lg transition"
                          >
                            <Trash className="w-4 h-4 sm:w-5 sm:h-5" />
                          </button>
                          <button
                            onClick={() => handleDeleteModal(cliente)}
                            className="p-1.5 sm:p-2 text-yellow-700 hover:text-yellow-800 hover:bg-yellow-100 rounded-lg transition"
                          >
                            <Navigation
                              onClick={() => handleNavigate(cliente)}
                              className="w-4 h-4 sm:w-5 sm:h-5"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="p-4 text-center text-gray-500">
                      No hay clientes disponibles.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            
            
          </div>
          <div className="flex justify-center items-center gap-4 mt-6">
              <button
                onClick={() => setCurrentPage(1)}
                className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
                  currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
                }`}
                disabled={currentPage === 1}
              >
                <ChevronFirst className="w-5 h-5 text-text" />
              </button>

              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
                  currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
                }`}
              >
                <ChevronLeft className="w-5 h-5 text-text" />
              </button>
              <span className="text-sm text-text">
                Página {currentPage} de {totalPages}
              </span>
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
                  currentPage === totalPages
                    ? "cursor-not-allowed opacity-50"
                    : ""
                }`}
              >
                <ChevronRight className="w-5 h-5 text-text" />
              </button>

              <button
                onClick={() => setCurrentPage(totalPages)}
                className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
                  currentPage === totalPages
                    ? "cursor-not-allowed opacity-50"
                    : ""
                }`}
                disabled={currentPage === totalPages}
              >
                <ChevronLast className="w-5 h-5 text-text " />
              </button>
            </div>
        </div>
      </section>
    </div>
  );
}
